const reasons = ["Business", "Dealership", "Transport"];
const types = ["Internal", "External", "Vendor"];
const divisions = ["Compressor", "Pumps", "Glass", "Filters", "WaterHeater"];
const categories = ["A", "B", "C", "D"];
const priorities = ["Low", "Medium", "High"];
const departments = [
  "Strategy",
  "Finance",
  "Quality",
  "Maintenance",
  "Stores",
];
const locations = ["Pune", "Mumbai", "Delhi"];
const status = ["Registered", "Cancelled", "Running", "Closed"];
export {
  categories,
  priorities,
  status,
  departments,
  locations,
  divisions,
  types,
  reasons,
};
